import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { User } from "@/domain/models";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountImage',
  props: {
    userSession: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    src: _ctx.userSession?.profile_image,
    alt: "...",
    class: "avatar-img rounded-circle"
  }, null, 8, _hoisted_1))
}
}

})